import React from 'react';
import PropTypes from 'prop-types';
import { FakeText, IconButton, Card } from '@totalsoft/rocket-ui';
import EngineScoringHeaderComponent from './EngineScoringHeaderComponent';
import { useTranslation } from 'react-i18next';
import { Description } from '@mui/icons-material';
import { isValid } from '@totalsoft/pure-validations-react';

const EngineScoringHeaderCard = ({
  header,
  isReadOnly,
  dispatch,
  filterTypes,
  targetContexts,
  periodSelectionList,
  onSave,
  validation,
  onChangeTitle,
  partnerTypes,
  partnerBaseTypes,
  loading,
  engineScoringId,
  canTestScoring,
}) => {
  const { t } = useTranslation();

  const onSaveHeader = () => {
    onSave('OnSaveHeader', {});
  };

  return (
    <Card
      icon={Description}
      iconColor='primary'
      title={t('EngineScoring.Header')}
      actions={
        <IconButton
          type='save'
          fontSize='medium'
          color='transparent'
          tooltip={t('SaveChanges')}
          onClick={onSaveHeader}
          disabled={!(validation |> isValid) || !header.changed || header.saving}
        />
      }
    >
      {loading ? (
        <FakeText lines={10} />
      ) : (
        <EngineScoringHeaderComponent
          filterTypes={filterTypes}
          engineScoringId={engineScoringId}
          header={header}
          isReadOnly={isReadOnly}
          dispatch={dispatch}
          targetContexts={targetContexts}
          periodSelectionList={periodSelectionList}
          partnerTypes={partnerTypes}
          validation={validation}
          onChangeTitle={onChangeTitle}
          partnerBaseTypes={partnerBaseTypes}
          canTestScoring={canTestScoring}
        />
      )}
    </Card>
  );
};

EngineScoringHeaderCard.propTypes = {
  header: PropTypes.object,
  isReadOnly: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  filterTypes: PropTypes.array,
  targetContexts: PropTypes.array,
  periodSelectionList: PropTypes.array,
  onSave: PropTypes.func.isRequired,
  validation: PropTypes.object,
  onChangeTitle: PropTypes.func,
  partnerTypes: PropTypes.array,
  partnerBaseTypes: PropTypes.array,
  engineScoringId: PropTypes.number,
  canTestScoring: PropTypes.bool.isRequired,
};

export default EngineScoringHeaderCard;
